import {RRFuelInvoiceWithExtras} from "../../types/RRFuelInvoiceType";

const getInvoiceDayTimestamp = (invoice: RRFuelInvoiceWithExtras): number => {
    const invoiceDate = invoice.invDate;
    return Date.UTC(invoiceDate.getFullYear(), invoiceDate.getMonth(), invoiceDate.getDate());
};

const getComparableMileage = (value: number | null | undefined): number => {
    return typeof value === "number" && Number.isFinite(value) ? value : Number.MAX_SAFE_INTEGER;
};

/**
 * Подрежда зарежданията хронологично, а при една и съща дата – по километраж.
 * Така последователността на няколко зареждания за едно МПС остава предвидима.
 */
export const sortFuelInvoicesByDateAndMileage = <T extends RRFuelInvoiceWithExtras>(invoices: readonly T[]): T[] => {
    return [...invoices].sort((firstInvoice, secondInvoice) => {
        const dayDifference = getInvoiceDayTimestamp(firstInvoice) - getInvoiceDayTimestamp(secondInvoice);
        if (dayDifference !== 0) {
            return dayDifference;
        }

        const startKmDifference = getComparableMileage(firstInvoice.startKm ?? firstInvoice.start_km)
            - getComparableMileage(secondInvoice.startKm ?? secondInvoice.start_km);
        if (startKmDifference !== 0) {
            return startKmDifference;
        }

        const endKmDifference = getComparableMileage(firstInvoice.endKm ?? firstInvoice.end_km)
            - getComparableMileage(secondInvoice.endKm ?? secondInvoice.end_km);
        if (endKmDifference !== 0) {
            return endKmDifference;
        }

        return firstInvoice.id.localeCompare(secondInvoice.id);
    });
};
